import { VerifyEmailForm } from "@/components/form/VerifyEmailForm";

const VerifyEmailPage = () => {
  return <VerifyEmailForm />;
};

export default VerifyEmailPage;
